import styles from '../../SynchModal.scss';
import { TreeView } from '@/Components/TreeView/TreeView';
import { Button } from '@/Components/Controls/Button/Button';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import React from 'react';
import { useActiveLogisticTypesTreeViewOptions } from '@/Hooks/Options/useActiveLogisticTypeOptions';
import { MpOrdersApi } from '@/Api/MpOrders';
import { useLocalization } from '@/Hooks';
import { ButtonsWrapper } from '@/Components/Forms/ButtonsSection/ButtonsSection';

type Props = {
  closeModalWindow: () => void;
};

export function Logistic({ closeModalWindow }: Props) {
  const {
    modalWindows: {
      mpSynchronization: { ModalTabs },
    },
    modules: { Synchronize },
  } = useLocalization();

  const {
    activeLogisticTypesTreeViewItems,
    setSelectedLogisticTypes,
    logisticIds,
  } = useActiveLogisticTypesTreeViewOptions();

  const synchronizeLogistics = () => {
    MpOrdersApi.synchShippingsStatusesForOrders({ logistics: logisticIds }).then(() => {
      closeModalWindow();
    });
  };

  return (
    <div>
      <h3 className={styles.title}>{Synchronize}</h3>
      <p className={styles.text}>{ModalTabs.Logistic.text}</p>

      <TreeView
        className={styles.treeView}
        checkboxesMode={'selectAll'}
        selectionMode={'multiple'}
        onItemClick={() => null}
        items={activeLogisticTypesTreeViewItems}
        width={'100%'}
        onSelectionChanged={(ev) => {
          setSelectedLogisticTypes(ev.ids);
        }}
      />

      <ButtonsWrapper>
        <Button
          className={styles.wideButton}
          disabled={!logisticIds?.length}
          text={Synchronize}
          theme={BUTTON_THEMES.SUCCESS}
          onClick={synchronizeLogistics}
        />
      </ButtonsWrapper>
    </div>
  );
}
